import React from "react";
import PropTypes from "prop-types";
import ActivityLink from "../activity-types/connected/ActivityLink";
import { ResourceLink } from "../styled/activities";
import { Quote } from "./styled/activity-comment";

function getPersonComponent({
  clientId,
  clientName,
  isAgent,
  isRecommender,
  isCurrentlyViewedClient
}) {
  if (isAgent && !isCurrentlyViewedClient) {
    return (
      <ResourceLink to={`/clients/${clientId}`}>{clientName}</ResourceLink>
    );
  } else if (isRecommender) {
    return <span>You</span>;
  } else {
    return <strong>{clientName}</strong>;
  }
}

function ActivityRecommended({
  activityId,
  streamItemId,
  address,
  clientId,
  clientName,
  message,
  isAgent,
  isLiker,
  isCurrentlyViewedClient
}) {
  return (
    <ActivityLink isAgent={isAgent} activityId={activityId}>
      {getPersonComponent({
        clientId,
        clientName,
        isAgent,
        isLiker,
        isCurrentlyViewedClient
      })}{" "}
      recommended{" "}
      <ResourceLink to={`/stream_items/${streamItemId}`}>
        {address}
      </ResourceLink>
      {message && (
        <>
          : <Quote>{message}</Quote>
        </>
      )}
    </ActivityLink>
  );
}

ActivityRecommended.propTypes = {
  activityId: PropTypes.string.isRequired,
  streamItemId: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  isAgent: PropTypes.bool.isRequired,
  isRecommender: PropTypes.bool.isRequired,
  isCurrentlyViewedClient: PropTypes.bool.isRequired
};

export default ActivityRecommended;
